// src/theme/breakpoint/index.ts
var breakpoint = {
  xl: "1600px",
  lg: "1200px",
  md: "992px",
  sm: "768px",
  xs: "0px"
};
var breakpoint_default = breakpoint;

export { breakpoint_default as default };
